

































































































import Vue from "vue";
import identityAuthenClient from "@/services/identityAuthenClient";
import store from "@/store";
import userInfoProvider from "../../services/userInfoProvider";
import loginService from "@/services/identity-authen/loginService";

export default Vue.extend({
  name: "Login",
  data: () => ({
    showOtpInput: false,
    passwordWithOtp: false,
    isRequestUnlock: false,
    openId: "",
    redirectUrl: "",
    openIdConnectMessage: "",
    openIdConnectRedirectUrl: "",
    form: false,
    rules: {
      required: value => {
        return !!value || "Required";
      }
    },
    data: {},
    error: "",
    loginType: "",
    username: "",
    password: "",
    showPassword: false,
    rememberLogin: false,
    isWaiting: false,
    loader: null,
    prepareLoginResponse: null,
    src: ""
  }),
  watch: {
    data: {
      deep: true,
      handler() {
        this.isRequestUnlock = false;
      }
    }
  },
  methods: {
    async submit(callback) {
      const query = {
        domainId: "@any",
        type: "UsernamePassword",
        loginName: this.data.loginName,
        password: this.data.password,
        otp: this.data.otp
      };
      try {
        const response = await identityAuthenClient.login(query);
        if (response && response.error_info && response.error_info.error_code) {
          if (response.error_info.error_code === 205) {
            await this.$router.push({
              name: "change-password-for-first-time",
              params: response
            });
          } else {
            callback(response.error_info.message);
          }
          if (response.error_info.error_code === 423) {
            callback(response.error_info.message);
            this.isRequestUnlock = true;
          }
        } else {
          store.dispatch("setIsLoggedin", true);
          store.dispatch("setKeepLogin", this.rememberLogin);
          userInfoProvider.setAccessToken(response.token, this.rememberLogin);
          localStorage.setItem("login_name", this.data.loginName);
          this.$router.push({
            path: "prepare",
            query: {
              ctx: this.$route.query.ctx || ""
            }
          });
          callback();
        }
      } catch (e) {
        this.error = e;
        callback(e);
      }
    },
    openIdHandler() {
      const pathDefault = "/user/mfa-management";
      const locationUrl = location.origin;
      const url =
        this.openIdConnectRedirectUrl +
        "?redirect=" +
        locationUrl +
        pathDefault;
      window.open(url, "_self");
    }
  },
  async created() {
    this.src = localStorage.getItem("loginSrc");
    this.prepareLoginResponse = loginService.getPrepareLoginResponse();
    if (
      this.prepareLoginResponse &&
      this.prepareLoginResponse.available_login_methods &&
      this.prepareLoginResponse.available_login_methods.length
    ) {
      for (const loginMethod of this.prepareLoginResponse
        .available_login_methods) {
        if (
          loginMethod.type &&
          loginMethod.type === "open_id_connect" &&
          this.openIdConnectMessage === ""
        ) {
          this.openIdConnectMessage = loginMethod.message;
          this.openIdConnectRedirectUrl = loginMethod.redirect_url;
        } else if (
          loginMethod.type &&
          loginMethod.type === "radius" &&
          loginMethod.password_with_otp
        ) {
          this.passwordWithOtp = true;
        }
      }
    }
  }
});
